/** Indian weighbridge convention: 1 quintal (qtl) = 100 kg. */

export const KG_PER_QTL = 100;

export function kgToQtl(kg) {
  const n = Number(kg);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round((n / KG_PER_QTL) * 100) / 100;
}

export function qtlToKg(qtl) {
  const n = Number(qtl);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * KG_PER_QTL * 100) / 100;
}

export function formatKg(kg) {
  if (kg == null || !Number.isFinite(Number(kg))) return "—";
  return Number(kg).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

/** Format stored qtl as kg for operator-facing labels. */
export function formatWeightKg(qtl) {
  const kg = qtlToKg(qtl);
  return kg != null ? `${formatKg(kg)} kg` : null;
}
